import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en.json";

// English only at launch (decision 6); every string is externalised so FR/ES/RU are translation-only work.
void i18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
